<template>
  <div>
    <div class="swiper">
      <div class="toptexts">
        <div class="imgtitle">{{ detail.Name }}</div>
        <div class="texts">{{ detail.Summary }}</div>
      </div>
    </div>
    <div class="width1200 ma-lr-auto ma-t-20" v-html="detail.Content"></div>
    <div class="width1000 ma-lr-auto ma-t-20 ma-b-20">
      <div class="flex">
        <div class="t-center conInfo-item">
          <img src="../img/map.png" alt="" srcset="" class="icon-img" />
          <div class="ma-t-20">公司地址</div>
          <div class="ma-t-20 c-333">上海市浦东软件园(三林园)1号楼5楼</div>
        </div>
        <div class="t-center conInfo-item">
          <img src="../img/phone.png" alt="" srcset="" class="icon-img" />
          <div class="ma-t-20">联系电话</div>
          <div class="ma-t-20 c-333">021-5068-7989<br />180-1884-7708</div>
        </div>
        <div class="t-center conInfo-item">
          <img src="../img/email.png" alt="" srcset="" class="icon-img" />
          <div class="ma-t-20">电子邮箱</div>
          <div class="ma-t-20 c-333">contact@fztek.net</div>
        </div>
      </div>
      <div class="ma-t-20 form-input">
        <div>我的需求</div>
        <el-input
          v-model="name"
          maxlength="5"
          placeholder="请输入姓名"
          class="ma-t-10"
        ></el-input>
        <el-input
          placeholder="请输入联系方式"
          maxlength="11"
          v-model="phone"
          class="ma-t-20"
        ></el-input>
        <el-select
          v-model="Category"
          placeholder="请选择"
          class="ma-t-20 width100"
        >
          <el-option
            v-for="item in typeOptions"
            :key="item.Name"
            :label="item.Name"
            :value="item.Name"
          >
          </el-option>
        </el-select>
        <el-input
          type="textarea"
          rows="5"
          placeholder="请输入您的需求"
          v-model="content"
          class="ma-t-20"
        ></el-input>
        <div class="ma-t-50 flex f-center f-jcenter btn-submit ma-lr-auto" @click="submit">
          提交
        </div>
      </div>
    </div>
  </div>
</template>
<style>
    .form-input .el-input__inner, .form-input .el-textarea__inner {
        background-color: #eee;
    }
</style>
<style lang="scss" scoped>
    /* 大屏 宽度大于768 */
    @media (min-width: 768px) {
        .width1200 {
            width: 1200px;
        }

        .width1000 {
            width: 1000px;
        }

        .ma-t-50 {
            margin-top: 50px;
        }

        .btn-submit {
            width: 20%;
            height: 40px;
            border-radius: 20px;
            font-size: 14px;
            line-height: 40px;
            color: #ffffff;
            background: #fb004d;
            cursor: pointer;
        }

        .swiper {
            width: 100%;
            height: 314px;
            background-image: url(../img/three_1.png);
            background-size: 100% 100%;
            background-repeat: no-repeat;
            position: relative;

            .toptexts {
                width: 736px;
                position: absolute;
                top: 28%;
                margin: 0 auto;
                left: 50%;
                margin-left: -368px;
                font-size: 20px;
                font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
                color: #fff;
                opacity: 0.75;
                text-align: center;

                .texts {
                    line-height: 30px;
                    letter-spacing: 3px;
                    font-size: 16px;
                }

                .imgtitle {
                    font-size: 24px;
                    font-weight: bold;
                    margin-bottom: 20px;
                }
            }
        }

        .icon-img {
            width: 50px;
            height: 50px;
        }

        .conInfo-item {
            width: 33%;
            background: #fff;
            border: 0.5px solid #e9e7e7;
            padding-top: 50px;
            padding-bottom: 50px;
        }
    }
</style>
<script>
import { getType,demand, getOther,getuser } from "../api.js";
export default {
  name: "contactus",
  components: {},
  data() {
    return {
      detail: {},
      name: "",
      phone: "",
      content: "",
      Category: "",
      typeOptions: [],
    };
  },
  created() {
    this.getOthers();
    this.loadDataType()
    this.getusers()
  },
  beforeRouteEnter(to, from, next) {
    window.scroll(0, 0);

    next();
  },
  methods: {
    login() {
      let token = localStorage.getItem("AccessToken") || "";
      if (!token) {
        this.$confirm("您还未登录请先登录?", "提示", {
          confirmButtonText: "去登录",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$router.push("/login");
          })
          .catch(() => {
            return false;
          });
      } else {
        return true;
      }
    },
    //获取首页数据
    getOthers() {
      getOther({ code: "contactus" }).then((res) => {
        this.detail = res.data.Data;
      });
    },
    //获取解决方案分类
    loadDataType() {
      getType({flag:1}).then((res) => {
        this.typeOptions = res.data.Data;
      });
    },
    submit() {
      if(!this.login()){return}
      let reg = 11 && /^((13|14|15|17|18|16|19|11|12)[0-9]{1}\d{8})$/;
      if (this.name == "") {
        this.$message.error("请输入姓名");
        return;
      }
      if (this.phone.length < 1) {
        this.$message.error("手机号不能为空哦");
        return;
      } else if (!reg.test(this.phone)) {
        this.$message.error("手机格式不正确");
        return;
      }

      if (this.content == "") {
        this.$message.error("请输入需求");
        return;
      }
      let token = localStorage.getItem("AccessToken");
      let data = {
        Content: this.content,
        Phone: this.phone,
        Name: this.name,
        Token: token,
        Category: this.Category,
      };
      demand(data).then((res) => {
        let massage = "";
        if (res.data.Code == 0) {
          massage = "提交成功";
          this.content = "";
          this.phone = "";
          this.name = "";
          this.Category = ""

        } else {
          massage = res.data.Message;
        }
        this.$message({
          message: massage,
          type: "success",
          center: true,
          duration: 1000,
          customClass: "sps",
        });
      });
    },
    

    //获取用户信息
    getusers() {
      let token = localStorage.getItem("AccessToken") || "";
      getuser({ token: token }).then((res) => {
        if (res.data.Code == 0) {
          this.name = res.data.Data.Name;
          this.phone = res.data.Data.Phone;
        }
      });
    },
  },
};
</script>
